import React from 'react'
import Footer from "./view/Footer";

const FooterContainer  = () => {
    return (
        <Footer/>
    );
}

export default FooterContainer;


// WEBPACK FOOTER //
// ./src/components/company/footer/FooterContainer.jsx